export default "__VITE_ASSET__758c7a79__"